export default "__VITE_ASSET__d9152857__"